import { render, staticRenderFns } from "./analysisIndvidual.vue?vue&type=template&id=20c0fde5&scoped=true"
import script from "./analysisIndvidual.vue?vue&type=script&lang=js"
export * from "./analysisIndvidual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c0fde5",
  null
  
)

export default component.exports